import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3eb61cee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SummaryAdd" }
const _hoisted_2 = { class: "form-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red-color" }, "*"),
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, [
    /*#__PURE__*/_createTextVNode("文件 "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"#999999","font-size":"12px"} }, "（可上传图片、word、excel、pdf）")
  ])
], -1))
const _hoisted_5 = {
  key: 0,
  class: "uploader"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_7 = {
  key: 1,
  class: "uploader"
}
const _hoisted_8 = { class: "self_flex_row self_justify_between self_align_center" }
const _hoisted_9 = { class: "self_flex_row" }
const _hoisted_10 = { class: "image" }
const _hoisted_11 = { class: "file_type" }
const _hoisted_12 = { class: "type-rd" }
const _hoisted_13 = { style: {"font-size":"10px"} }
const _hoisted_14 = {
  class: "",
  style: {"color":"#000000"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_16 = { class: "submit-btn" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 提交 ")

import { onMounted, reactive, ref } from 'vue'
import { uploadFile1 } from '@/apis/public/file'
import { saveProject, materialSave } from '@/apis/dataSummary'
import { useRouter } from 'vue-router'
import { Toast } from 'vant'
import dayjs from 'dayjs'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const state = reactive({
  suffixName: '', //
  suffixSize: '', //
  project_name: '--',
  summaryList: {} as saveProject
})

const showFile = ref(false)
const to_clear = () => {
  showFile.value = false
  state.suffixName = ''
  state.summaryList = {
    id: null,
    project_id: null,
    staff_id: null,
    file_name: '',
    file: null
  }
  state.summaryList.project_id = Number(router.currentRoute.value.query.project_id)
}
//上传文件
const afterRead = (file: any) => {
  Toast.loading({
    message: '上传中...',
    forbidClick: true,
    duration: 0
  })
  console.log('afterRead.file ===>', file)
  state.suffixName = file.file.name.substring(file.file.name.lastIndexOf('.') + 1)
  console.log('====substring>', state.suffixName)

  state.suffixSize = sizeTostr(file.file.size)
  // 循环上传
  file.status = 'uploading'
  file.message = '上传中...'

  const param = new FormData()
  param.append('uploadFile', file.file, file.file.name)

  uploadFile1(param).then((res: any) => {
    if (res.code == 200) {
      state.summaryList.file = res.data.url
      file.status = 'done'
      file.message = '上传成功'
      Toast.clear()
      showFile.value = true
    } else {
      file.status = 'failed'
      file.message = '上传失败'
    }
  })
}

const sizeTostr = size => {
  var data = ''
  if (size < 0.1 * 1024) {
    //如果小于0.1KB转化成B
    data = size.toFixed(2) + 'B'
  } else if (size < 0.1 * 1024 * 1024) {
    //如果小于0.1MB转化成KB
    data = (size / 1024).toFixed(2) + 'KB'
  } else if (size < 0.1 * 1024 * 1024 * 1024) {
    //如果小于0.1GB转化成MB
    data = (size / (1024 * 1024)).toFixed(2) + 'MB'
  } else {
    //其他转化成GB
    data = (size / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
  }
  var sizestr = data + ''
  var len = sizestr.indexOf('\.')
  var dec = sizestr.substr(len + 1, 2)
  if (dec == '00') {
    //当小数点后为00时 去掉小数部分
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2)
  }
  return sizestr
}

const onSubmit = async () => {
  console.log(state.summaryList)
  const res = await materialSave(state.summaryList)
  if (res.code == 200) {
    console.log(res.data)
    Toast.success({
      message: res.msg,
      duration: 500,
      onClose: () => {
        router.back()
      }
    })
  } else {
    Toast(res.msg)
  }
}
const StaffInfo = ref({
  currentTime: '--', // 当前时间
  company_froms: {
    cf_name: '--'
  },
  name: '--'
})
onMounted(() => {
  StaffInfo.value = JSON.parse(localStorage.getItem('STAFFINFO'))
  StaffInfo.value.currentTime = dayjs().format('YYYY-MM-DD HH:mm')
  state.project_name = router.currentRoute.value.query.project_name.toString()
  state.summaryList.project_id = Number(router.currentRoute.value.query.project_id)
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_common_info = _resolveComponent("common-info")!
  const _component_bottom_button = _resolveComponent("bottom-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_form, { onSubmit: onSubmit }, {
        default: _withCtx(() => [
          _createVNode(_component_van_cell_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_cell, {
                title: "项目名称",
                value: _unref(state).project_name
              }, null, 8, ["value"]),
              _hoisted_3,
              _createVNode(_component_van_field, {
                label: "文件名称",
                modelValue: _unref(state).summaryList.file_name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).summaryList.file_name) = $event)),
                "input-align": "right",
                name: "text",
                placeholder: "请输入",
                required: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_cell_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_van_cell, null, {
                    title: _withCtx(() => [
                      _hoisted_4
                    ]),
                    label: _withCtx(() => [
                      (!showFile.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_van_uploader, {
                              "after-read": afterRead,
                              accept: "*"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_van_button, {
                                  icon: "plus",
                                  type: "primary",
                                  block: "",
                                  plain: ""
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_6
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                  (_unref(state).suffixName == 'pdf' || _unref(state).suffixName == 'pptx' || _unref(state).suffixName == 'ppt')
                                    ? (_openBlock(), _createBlock(_component_van_image, {
                                        key: 0,
                                        width: "30",
                                        height: "30",
                                        fit: "contain",
                                        src: require('@/assets/project/pdf.png')
                                      }, null, 8, ["src"]))
                                    : _createCommentVNode("", true),
                                  (_unref(state).suffixName == 'docx' || _unref(state).suffixName == 'doc')
                                    ? (_openBlock(), _createBlock(_component_van_image, {
                                        key: 1,
                                        width: "30",
                                        height: "30",
                                        fit: "contain",
                                        src: require('@/assets/project/word.png')
                                      }, null, 8, ["src"]))
                                    : _createCommentVNode("", true),
                                  (_unref(state).suffixName == 'xlsx' || _unref(state).suffixName == 'xls')
                                    ? (_openBlock(), _createBlock(_component_van_image, {
                                        key: 2,
                                        width: "30",
                                        height: "30",
                                        fit: "contain",
                                        src: require('@/assets/project/excel.png')
                                      }, null, 8, ["src"]))
                                    : _createCommentVNode("", true),
                                  (
                            _unref(state).suffixName == 'jpeg' ||
                            _unref(state).suffixName == 'gif' ||
                            _unref(state).suffixName == 'png' ||
                            _unref(state).suffixName == 'jpg'
                          )
                                    ? (_openBlock(), _createBlock(_component_van_image, {
                                        key: 3,
                                        width: "30",
                                        height: "30",
                                        fit: "contain",
                                        src: require('@/assets/project/pisc.png')
                                      }, null, 8, ["src"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(state).suffixName), 1),
                                  _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(state).suffixSize), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_van_icon, {
                                  onClick: to_clear,
                                  name: "clear"
                                })
                              ])
                            ])
                          ]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_15,
              _createVNode(_component_common_info, { StaffInfo: StaffInfo.value }, null, 8, ["StaffInfo"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_bottom_button, {
              round: "",
              block: "",
              type: "primary",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})